import { AuthClient } from '@micro-frontend-react/employee-experience/lib/AuthClient';
import { TelemetryClient } from '@micro-frontend-react/employee-experience/lib/TelemetryClient';
import { HttpClient } from '@micro-frontend-react/employee-experience/lib/HttpClient';
import { GraphClient } from '@micro-frontend-react/employee-experience/lib/GraphClient';
import { Shell } from '@micro-frontend-react/employee-experience/lib/Shell';
import { withStore } from '@micro-frontend-react/employee-experience/lib/withStore';
import { StoreBuilder } from '@micro-frontend-react/employee-experience/lib/StoreBuilder';
import { ReducerRegistry } from '@micro-frontend-react/employee-experience/lib/ReducerRegistry';
import { applicationsReducer, ApplicationsReducerName, applicationsSagas } from './Shared/Store/Applications';
import { componentsReducer, ComponentsReducerName, componentsSagas } from './Shared/Store/Components';
import { contentsReducer, ContentsReducerName, contentsSagas } from './Shared/Store/Contents';
import { isAdminReducer, IsAdminReducerName, isAdminSagas } from './Shared/Store/IsAdmin';
import { viewsReducer, ViewsReducerName, viewsSagas } from './Shared/Store/Views';

const telemetryClient = new TelemetryClient({
  instrumentationKey: __INSTRUMENTATION_KEY__,
  UTPConfig: {
    EnvironmentName: 'Non-Production',
    ServiceOffering: 'Example Service Offering',
    ServiceLine: 'Example Service Line',
    Service: 'Example Service',
    ComponentName: 'Example Component',
    ComponentId: 'Example Id',
  },
  defaultProperties: {
    appName: __APP_NAME__,
  },
});
const authClient = new AuthClient(
  {
    auth: {
      clientId: __CLIENT_ID__,
      redirectUri: window.location.origin,
      authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
    },
  },
  telemetryClient
);

const httpClient = new HttpClient(telemetryClient, authClient);
const graphClient = new GraphClient(httpClient);

const reducerRegistry = new ReducerRegistry()
  .register(ApplicationsReducerName, applicationsReducer)
  .register(ComponentsReducerName, componentsReducer)
  .register(IsAdminReducerName, isAdminReducer)
  .register(ContentsReducerName, contentsReducer)
  .register(ViewsReducerName, viewsReducer);

const storeResult = new StoreBuilder(reducerRegistry, {})
  .configureLogger(__IS_DEVELOPMENT__)
  .configureSaga({ telemetryClient, authClient, httpClient, graphClient, appName: __APP_NAME__ })
  .addRootSagas([applicationsSagas, componentsSagas, isAdminSagas, viewsSagas, contentsSagas])
  .configurePersistor({
    whitelist: __IS_DEVELOPMENT__ ? [] : undefined,
  })
  .build();

export const ShellWithStore = withStore(storeResult)(Shell);
